import { Box, Grid } from "@mui/material"
import { mahiBffUrl } from "../../../data/hikoFetch"
import { DlspGenericFileUploadPanel } from "./DlspGenericFileUploadPanel"
import { SmallLabelledText } from "../../styled/SmallLabelledText"

const bffBaseUrl = mahiBffUrl()

export function DlspFieldFileUploadPanel({icp, fieldPhotosRequired, desktopQABy, desktopQAComments}) {

    const bffUploadPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/field-inspection-image/upload?icp=${icp}`
    const bffGetAllPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/field-inspection-image/get-all`
    const bffDeletePath = `/bff/decommissioned-lines-service/api/decommissioned-lines/field-inspection-image/delete`

    const fieldPhotosParagraphs = newlineToBr(fieldPhotosRequired)
    const desktopQAParagraphs = newlineToBr(desktopQAComments)

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <SmallLabelledText label={`Required Field Photos (From Desktop QA: ${desktopQABy})`} text={fieldPhotosParagraphs} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SmallLabelledText label={`Field Instructions (From Desktop QA: ${desktopQABy})`} text={desktopQAParagraphs} />
                </Grid>
            </Grid>
            <DlspGenericFileUploadPanel icp={icp} bffBaseUrl={bffBaseUrl} bffUploadPath={bffUploadPath} bffGetAllPath={bffGetAllPath} bffDeletePath={bffDeletePath} />
        </Box>
    )
}

const newlineToBr = (text) => {
    const paragraphs = (text || '').split('\n').map((item, key) => {
        return <span key={key}>{item}<br/></span>
    })
    return paragraphs
}